// extracted by mini-css-extract-plugin
export default {"container":"HCr4OD","title":"WbZSWX","stars":"RYuCul","animStar":"pkEeV4","stars2":"hqixLu","stars3":"R7UrJL"};